import { DocumentType } from './documents'

// Archived types stay in the document types query for labels of existing documents, but can't be picked for new uploads
export const getUploadableDocumentTypes = (documentTypes: DocumentType[]): DocumentType[] =>
  documentTypes.filter((documentType) => !documentType.isArchived)
